import React, { useState } from 'react'
import useUser from '../hooks/useUser';

function UserProfile() {
  const{data:user}  = useUser()
  const [activeTab,setActiveTab]=useState("collections")
 return (
  <div className="w-full flex flex-col items-center justify-start py-12">
    <div className="w-full h-72 bg-blue-50">
      <img
        src="https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?ixlib=rb-4.0.3&ixid=M3wMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"
        alt=""
        className="w-full h-full object-cover"
      />

<div className="flex items-center justify-center flex-col gap-4">
  {user?.photoURL ? (
    <React.Fragment>
      <img
        src={user?.photoURL}
        className="w-24 h-24 rounded-full border-2 border-white -mt-12 shadow-md"
        alt=""
        referrerPolicy="no-referrer"
        loading="lazy"
      />
    </React.Fragment>
  ) : (
    <React.Fragment>
      <img
        src={
          "https://img.freepik.com/premium-vector/adorable-cyberpunk-dj-vector_868778-499.jpg"
        }
        className="w-24 h-24 rounded-full border-2 border-white -mt-12 shadow-md"
        alt=""
        referrerPolicy="no-referrer"
        loading="lazy"
      />
    </React.Fragment>
  )}
  <p className='text-2xl text-txtDark'>{user?.displayName}</p>

</div>
{/**tabs */}
<div className='flex items-center justify-center mt-12'>
<div className={`px-4 py-2 rounded-md flex items-center justify-center gap-2 group cursor-pointer`} onClick={()=>setActiveTab("collections")}>
<p className={`text-base text-txtPrimary group-hover:text-blue-600 px-4 py-1 rounded-full ${activeTab === 'collections' && 'bg-white shadow-md text-blue-600'}`}>
  Collections
</p>
    </div>

    {/**one more time */}
    <div className={`px-4 py-2 rounded-md flex items-center justify-center gap-2 group cursor-pointer`} onClick={()=>setActiveTab("resumes")}>
<p className={`text-base text-txtPrimary group-hover:text-blue-600 px-4 py-1 rounded-full ${activeTab === 'resumes' && 'bg-white shadow-md text-blue-600'}`}>
  My Resumes
</p>
    </div>
    {/**one more time */}
</div>
{/**tab content */}
</div>
  </div>
);

}

export default UserProfile
